import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { toCSSVar } from '@chakra-ui/react';
import { Global, ThemeProvider as EmotionThemeProvider } from '@emotion/react';
export var ThemeProvider = function ThemeProvider(props) {
  var cssVarsRoot = props.cssVarsRoot,
    theme = props.theme,
    children = props.children,
    _props$cssVars = props.cssVars,
    cssVars = _props$cssVars === void 0 ? false : _props$cssVars;
  var computedTheme = React.useMemo(function () {
    return toCSSVar(theme);
  }, [theme]);
  return /*#__PURE__*/React.createElement(EmotionThemeProvider, {
    theme: computedTheme
  }, cssVars && /*#__PURE__*/React.createElement(CSSVars, {
    root: cssVarsRoot
  }), children);
};
var CSSVars = function CSSVars(_ref) {
  var _ref$root = _ref.root,
    root = _ref$root === void 0 ? ':host, :root' : _ref$root;
  var selector = [root, '[data-theme]'].join(',');
  return /*#__PURE__*/React.createElement(Global, {
    styles: function styles(theme) {
      return _defineProperty({}, selector, theme.__cssVars);
    }
  });
};